

export const isInvalidTimeString = (value: string | null) => {
    return value ? value.match(/^[0-9]+:[0-9]{2}$/) == null : false;
};


// WEBPACK FOOTER //
// ./src/helpers/Validation.ts